module.exports = require("core-js/library/fn/object/create");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/create.js
// module id = 261
// module chunks = 168707334958949